import { type FC } from 'react'

import {
  EXPERIMENTS_TRACK_EVENT_PDP_CART_DRAWER_GO_TO_CART,
  experimentsTrackEvent,
} from '../../../experiments/eventTracking'
import { useGlobalConfigContext } from '../../../global-config'

import { CartIntermediateContinueShoppingButton } from './CartIntermediateContinueShoppingButton'
import { CartIntermediateGoToCartButton } from './CartIntermediateGoToCartButton'

type CartIntermediateCtaButtonsProps = {
  handleClose: () => void
}

export const CartIntermediateCtaButtons: FC<
  CartIntermediateCtaButtonsProps
> = ({ handleClose }) => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="mb-5 mt-4 flex flex-col justify-between gap-4 tablet:flex-row">
      <CartIntermediateGoToCartButton
        onClick={() => {
          experimentsTrackEvent(
            globalConfig,
            EXPERIMENTS_TRACK_EVENT_PDP_CART_DRAWER_GO_TO_CART,
          )
          handleClose()
        }}
      />
      <CartIntermediateContinueShoppingButton onClick={handleClose} />
    </div>
  )
}
